import styled from 'styled-components'
import { theme } from '@/client/components'
import borders from '@/client/components/theme/borders'
import breakpoint from '@/client/components/theme/breakpoint'
const { space, color } = theme

export const ContactForm = styled.div`
  background-color: ${color.grayscale.lighter};
  padding: ${space.xl2};
  border-radius: 0 ${space.xl4} 0 0;
  margin-right: 0;
  margin-bottom: ${space.xl};

  & .checkbox-desc-box {
    line-height: 1.4;
    color: ${color.grayscale.dark};
    margin-bottom: ${space.lg};

    @media (min-width: ${breakpoint.lg2}) {
      margin-bottom: ${space.xs};
    }
  }

  @media (min-width: ${breakpoint.hd}) {
    margin-right: ${space.lg};
    margin-bottom: 0;
  }

  .modal {
    opacity: 1;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .modal-hidden {
    opacity: 0;
    transition: opacity 0.5s ease, transform 0.5s ease;
  }

  .noLegend {
    padding: 0 !important;
  }
`
export const FieldList = styled.div<{ fullWidth?: boolean }>`
  gap: ${space.lg};
  display: grid;

  @media (min-width: ${breakpoint.lg}) {
    grid-template-columns: ${({ fullWidth }) => (fullWidth ? '100%' : 'repeat(2, 1fr)')};

    & > *:nth-child(3n) {
      grid-column: 1 / -1; /* Span every third item across all columns */
    }

    & #c_reason,
    & #Address,
    & #CountryId {
      grid-column: span 2;
    }

    & #c_reason,
    & #CountryId {
      height: 2.2rem;
    }
    & #StateId {
      height: 2.3rem;
    }

    & input {
      font-size: 0.9375rem;
    }
  }
`

export const FieldsetActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space.lg};

  & #refreshButton {
    border-radius: 2rem;
    border: 2px solid #c4c4c4;
    padding-left: 0;
    gap: 2rem;
    justify-content: flex-start;

    & .icon {
      font-size: 2.5rem;
    }
  }

  @media (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0;
  }
`

export const SecondColumn = styled.div`
  margin-left: 0;
  margin-top: ${space.lg};

  @media (min-width: ${breakpoint.lg2}) {
    margin-left: ${space.md};
    margin-top: ${space.xs};
  }
`
export const SideElement = styled.div`
  row-gap: ${space.xs};
  column-gap: ${space.xs};
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  margin: 0 ${space.xs} ${space.lg};

  @media (min-width: ${breakpoint.lg2}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${breakpoint.hd}) {
    row-gap: ${space.xl};
    column-gap: ${space.xl3};
  }
`
export const SideBox = styled.div<{ isActive?: boolean }>`
  gap: ${space.sm};
  display: grid;
  border: ${borders.sizes.md} solid ${color.grayscale.light};
  border-radius: ${space.lg};
  padding: ${space.md};
  background-color: ${(props) => (props.isActive ? color.grayscale.lighter : 'fffff')};
  transition: background-color 0.3s ease;
  color: #151616;

  &:hover {
    background-color: ${(props) => (props.isActive ? color.grayscale.lighter : color.grayscale.lighter)};
  }
`
export const ImageAligner = styled.div`
  display: none;

  @media (min-width: ${breakpoint.lg}) {
    display: block;
    padding-top: ${space.md};
  }
`
